<template>
  <!--
      	作者：luoyiming
      	时间：2020-06-01
      	描述：插件中心-分销-分销订单
      -->
  <div class="user">
    <!-- <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="佣金结算">
          <el-select v-model="formInline.is_settled" placeholder="是否结算佣金">
            <el-option label="全部" value="-1"></el-option>
            <el-option label="已结算" value="1"></el-option>
            <el-option label="未结算" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户id"><el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input></el-form-item>
        <el-form-item><el-button type="primary" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div> -->
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" size="small" border style="width: 100%" v-loading="loading">
          <!-- <el-table-column prop="order_master.create_time" label="商品信息">
            <template slot-scope="scope">
              <div class="product-info p-10-0" v-for="(item, index) in scope.row.order_master.product" :key="index">
                <div class="pic"><img v-img-url="item.image.file_path" alt="" /></div>
                <div class="info">
                  <div class="name gray3">{{ item.product_name }}</div>
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="name" label="姓名" width="300">
          </el-table-column>
          <el-table-column prop="price" label="提现金额" width="300">
          </el-table-column>
          <el-table-column prop="card_number" label="银行卡号" width="200">
          </el-table-column>
          <el-table-column prop="bank_of_deposit" label="开户行" >
          </el-table-column>

          <el-table-column prop="type" label="审核状态" >
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.type == 1">已通过</span>
              <span  v-if="scope.row.type == 0">待审核</span>
              <span class="red" v-if="scope.row.type == 2">已拒绝</span>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="提现时间" ></el-table-column>

          <!-- <el-table-column prop="mobile" label="交易状态" width="130">
            <template slot-scope="scope">
              <p>
                <span class="gray9">付款状态：</span>
                {{ scope.row.order_master.pay_status.text }}
              </p>
              <p>
                <span class="gray9">发货状态：</span>
                {{ scope.row.order_master.delivery_status.text }}
              </p>
              <p>
                <span class="gray9">收货状态：</span>
                {{ scope.row.order_master.receipt_status.text }}
              </p>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="referee.value" label="佣金结算" >
            <template slot-scope="scope">
              <span class="green" v-if="scope.row.is_settled == 1">已结算</span>
              <span class="red" v-if="scope.row.is_settled == 0">未结算</span>
            </template>
          </el-table-column> -->

          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="text" v-if="scope.row.type == 0" size="small">审核</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <Tag v-if="open_tag" :open_tag="open_tag" :form="userModel" @closeDialog="closeDialogFunc($event, 'tag')"></Tag>
  </div>
</template>

<script>
 import OrderApi from '@/api/order.js';
 import Tag from '../order/dialog/Tag2.vue'
export default {
  components: {
    /*编辑组件*/
    Tag
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      formInline: {
        is_settled: '-1',
        /*用户ID*/
        user_id: ''
      },
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      open_tag:false,
      userModel:{}
    };
  },
  props: {},
  watch: {
    $route(to, from) {
      if (to.query.user_id != null) {
        this.formInline.user_id = to.query.user_id;
      } else {
        this.formInline.user_id = '';
      }
      this.curPage = 1;
      this.getData();
    }
  },
  created() {
    if (this.$route.query.user_id != null) {
      this.formInline.user_id = this.$route.query.user_id;
    }
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*获取数据*/
    getData(user_id) {
      let self = this;
      let Params = {
        user_id: self.formInline.user_id,
        page: self.curPage,
        list_rows: self.pageSize,
        is_settled: self.is_settled
      };
      OrderApi.withdrawalList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.data;
          console.log(self.tableData,"看看你看卡")
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    //搜索
    onSubmit() {
      let self = this;
      self.loading = true;
      self.is_settled = self.formInline.is_settled;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*打开弹出层编辑*/
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },
    handleClick(item){
      this.userModel = item;
      this.open_tag = true;
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      console.log(e,f,"看看")
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      }
      if(f == 'tag'){
        this.open_tag = false;
        if(e.type == 'success'){
          this.getData();
        }
      }
    },
  }
};
</script>

<style scoped="">
  .referee-name{ width: 33.333333%;}
</style>



// WEBPACK FOOTER //
// src/views/order/cash/index.vue